import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarTooltipDirective } from '../../shell/sidebar-tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-pre-trade-check-nav-menu',
  imports: [RouterModule, SidebarTooltipDirective],
  template: `
    <div class="mt-1">
      <span class="sidebar-heading">Pre-Trade Check</span>
    </div>
    <div id="sidebar-nav" class="list-group text-sm-start">
      <a
        class="list-group-item rounded border-0 mb-1 p-1"
        [routerLink]="['/pre-trade-check', 'tradable']"
        ofSidebarTooltip="Tradable"
      >
        <i class="bi bi-patch-check me-2"></i>
        <span>Tradable</span>
      </a>
      <a
        class="list-group-item rounded border-0 mb-1 p-1"
        [routerLink]="['/pre-trade-check', 'rfq']"
        ofSidebarTooltip="RFQ"
      >
        <i class="bi bi-chat-right-quote me-2"></i>
        <span>RFQ</span>
      </a>
    </div>
  `
})
export class PreTradeCheckNavMenuComponent {}
